// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2fwe2","_label":"styles__label__3ywax","inputText":"styles_inputText__ql-6c"};